/* global google */
import React, { useCallback } from 'react'
import { useActions, useValues } from 'kea'

import I18n from 'lib/i18n'
import SlugAutocomplete from 'lib/tags/slug-autocomplete'
import { useMapsApiLoader } from 'lib/load/use-maps-api-loader'

import sceneLogic from '~/scenes/pages/request/logic'

const libraries = ['geometry', 'places']

const Location = () => {
  const { setLocation } = useActions(sceneLogic)
  const { location } = useValues(sceneLogic)

  const { isLoaded } = useMapsApiLoader({
    libraries
  })

  const placeholder = I18n.t('react.request.location.placeholder')

  const fetchOptionsParent = useCallback(
    (query, callback) => {
      if (query) {
        if (isLoaded) {
          const service = new google.maps.places.AutocompleteService()
          const params = {
            input: query,
            types: ['geocode']
          }
          service.getPlacePredictions(params, (predictions, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
              callback(
                predictions.map(({ description, place_id: placeId }) => ({
                  name: description,
                  placeId
                }))
              )
            } else {
              // eslint-disable-next-line node/no-callback-literal
              callback([])
            }
          })
        }
      } else {
        // eslint-disable-next-line node/no-callback-literal
        callback([])
      }
    },
    [isLoaded]
  )

  const handleChangeParent = useCallback(
    event => {
      const value = event.target.value
      setLocation(value)
    },
    [setLocation]
  )

  const performSearchParent = useCallback(
    query => {
      setLocation(query)
    },
    [setLocation]
  )

  return (
    <SlugAutocomplete
      inputId={'location-search'}
      className={'search-input-field'}
      inputValueParent={location}
      placeholder={placeholder}
      fetchOptionsParent={fetchOptionsParent}
      performSearchParent={performSearchParent}
      handleChangeParent={handleChangeParent}
      isRequestCategoryLocationAutoComplete
    />
  )
}

export default Location
